import React from 'react';
import { Modal, Row, Typography } from 'antd';
import { useQuery } from '@common/hooks';
import { MobileNotificationPreferences } from '@scheduling/graphql';
import { Colors } from 'works/legacy/lib/style-helper';

const { Text } = Typography;

export function NotificationPreferencesModal({
  workerId,
  open,
  setOpen,
}: {
  workerId: string;
  open: boolean;
  setOpen: (value: boolean) => void;
}) {
  const { data } = useQuery(MobileNotificationPreferences, {
    variables: { workerId },
  });

  return (
    <>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
        okText="OK"
        title="Notification Preferences"
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        {data?.mobileNotificationPreferences.map((preference, index) => (
          <Row
            key={preference.notificationName}
            style={{
              marginBottom:
                data?.mobileNotificationPreferences.length - 1 === index
                  ? 0
                  : 8,
            }}
          >
            <Text strong style={{ width: 126, color: Colors.midnightLighter }}>
              {preference.label}
            </Text>
            <Text>{preference.pushEnabled ? 'On' : 'Off'}</Text>
          </Row>
        ))}
      </Modal>
      <style jsx>
        {`
          :global(.notification-pref-item) {
            padding-bottom: 16px;
          }
        `}
      </style>
    </>
  );
}
